import { useState } from "react";
import { Get } from "../../../../../Request";

export const useSelectUser = (form, setform) => {
  const [loading, setloading] = useState({ btn: false });
  const checkMobile = async () => {
    setloading({ btn: true });
    setform({ ...form, result: { user: "no" } });
    await Get({ url: "/manager/check_user", data: form }).then(response => {
      setloading({ btn: false });
      setform({ ...form, result: response });
    });
  };
  const renderState = data => {
    if (data && data != "false" && data.length !== 10) {
      return false;
    } else {
      if (data.length === 10) {
        return true;
      } else {
        return false;
      }
    }
  };
  return {
    loading,
    checkMobile,
    renderState,
  };
};
